// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroThumbnailStack-cls1_lj0","cls2":"HeroThumbnailStack-cls2_A2B HeroThumbnailStack-cls1_lj0","treatment-gold":"HeroThumbnailStack-treatment-gold_Gcp"};